import React from "react";
import { PUBLIC_URL } from 'utils/publicUrl';

const RestoreIcon = () => {
  return (
    <img
      alt="icon"
      src={PUBLIC_URL + "/img/restore.png"}
      width="24"
      height="24"
    />
  );
};

export default RestoreIcon;
